import { render, staticRenderFns } from "./ConnectWallet.vue?vue&type=template&id=e5b80494&scoped=true"
import script from "./ConnectWallet.vue?vue&type=script&lang=js"
export * from "./ConnectWallet.vue?vue&type=script&lang=js"
import style0 from "./ConnectWallet.vue?vue&type=style&index=0&id=e5b80494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b80494",
  null
  
)

export default component.exports